import request from "../../config/axios";
import apiCache from "../../utils/cache";

const getAllProducts = () => {
  return request.get("/wp-json/wc/v3/products");
};
// , page
const getProductsByCategories = (slug,page) => {
  return request.get(
    `/wp-json/product-category/v1/list/?slug=${slug.toLowerCase()}&page=${page}`
  );
};

const getCategories = () => {
  return request.get(`/wp-json/wc/v3/products/categories`);
};

const getProductDetail = (id) => {
  return request.get(`/wp-json/wc/v3/products/${id}`);
};

const getVariations = (id) => {
  return request.get(`/wp-json/wc/v3/products/${id}/variations`);
};

// Optimized function to get categories with limited products
const getCategoriesWithProducts = async () => {
  const cacheKey = `categories_with_products`;

  // Check cache first
  const cachedData = apiCache.get(cacheKey);
  if (cachedData) {
    return cachedData;
  }

  try {
    // Get all categories first
    const categoriesResponse = await getCategories();

    // Check if response and data exist
    if (categoriesResponse.length < 1) {
      throw new Error("Invalid response from categories API");
    }

    // Get products for each category in parallel
    const categoriesWithProducts = await Promise.all(
      categoriesResponse.map(async (category) => {
        if (category.slug !== "chua-phan-loai") {
          try {
            // Try the custom endpoint first
            let productsResponse;
            try {
              productsResponse = await request.get(
                `/wp-json/product-category/v1/list/?slug=${category.slug.toLowerCase()}`
              );
            } catch (customEndpointError) {
              // Fallback to WooCommerce API
              productsResponse = await request.get(
                `/wp-json/wc/v3/products?category=${category.id}&per_page=4&status=publish`
              );
            }

            // Check if products response is valid
            const productsData =
              productsResponse && productsResponse.products
                ? productsResponse.products
                : [];

            return {
              ...category,
              products: Array.isArray(productsData) ? productsData : [],
            };
          } catch (error) {
            return {
              ...category,
              products: [],
            };
          }
        }
      })
    );

    // Cache the result
    apiCache.set(cacheKey, categoriesWithProducts);

    return categoriesWithProducts;
  } catch (error) {
    // Return empty array as fallback instead of throwing
    if (error.message && error.message.includes("Invalid response")) {
      throw error;
    }

    return [];
  }
};

const searchProducts = (keyword, limit) => {
  return request.get(
    `/wp-json/custom-search/v1/products?keyword=${keyword}&limit=${limit}`
  );
};

const getProductWithFilter = (
  category_slug,
  orderBy = [], // [{ key: "price", order: "ASC" }]
  types = "", // ["gold", "silver"] hoặc "gold"
  gemstone = "" // "moissanite"
) => {

  const params = new URLSearchParams();

  if (category_slug) params.append("category_slug", category_slug);

  // Thêm các cặp orderby/order
  orderBy.forEach(({ key, order }) => {
    if (key && order) {
      params.append("orderby", key);
      params.append("order", order);
    }
  });

  // Xử lý types: có thể là string hoặc array
  if (types && types.trim() !== "") {
    params.append("types", types);
  }

  if (gemstone && gemstone.trim() !== "") {
    params.append("gemstone", gemstone);
  }
  const query = params.toString();

  return request.get(`wp-json/custom/v1/products/?${query}`);
};

export {
  getAllProducts,
  getProductsByCategories,
  getCategories,
  getCategoriesWithProducts,
  getProductDetail,
  searchProducts,
  getProductWithFilter,
  getVariations,
};
